import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/main.css'
import { mixinBaseUrl } from './mixins'

createApp(App).use(store).use(router).mixin(mixinBaseUrl).mount('#app')
